import { render } from "./HomeColonialMarket.vue?vue&type=template&id=ba57ee58&scoped=true"
import script from "./HomeColonialMarket.vue?vue&type=script&lang=js"
export * from "./HomeColonialMarket.vue?vue&type=script&lang=js"

import "./HomeColonialMarket.vue?vue&type=style&index=0&id=ba57ee58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba57ee58"]])

export default __exports__